import { withLoader, withAsyncEnterLoader } from 'util/routeHelper';
import { getOrderById } from 'actions/booking';

export default store => ({
	path: 'print',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'print',
				),
			store,
			'PRINT',
		),
	},
	onEnter: withAsyncEnterLoader(
		async ({ params: { id: orderId } }, __, updateRatio) => {
			updateRatio(0.5);
			await store.dispatch(getOrderById(orderId));
			updateRatio(0.8);
		},
		store,
		'ENTER_PRINT',
	),
});



// WEBPACK FOOTER //
// ./src/routes/User/Booking/Print/index.js